module.exports = __webpack_public_path__ + "static/media/georgia-aquarium.ddf9a313.jpg";